<template>
  <div class="sticky top-0 z-50">
    <div
      class="z-50 flex h-16 items-center bg-gray-900 bg-opacity-70 backdrop-blur-lg"
    >
      <section-container>
        <div class="relative flex justify-between items-center">
          <nuxt-link
            to="https://bigleaphealth.com"
            target="_blank"
            aria-label="Visit Big Leap Health website"
          >
            <logo class="hidden md:block h-12 p-1" />
            <mobile-logo class="block md:hidden h-6" />
          </nuxt-link>
          <div class="flex w-full items-center justify-end">
            <ui-button
              variant="primary"
              type="button"
              @click="onClick"
              class="h-12"
              >Schedule Now</ui-button
            >
          </div>
        </div>
      </section-container>
    </div>
  </div>
</template>

<script setup>
import Logo from "~/assets/images/Logo.svg";
import MobileLogo from "~/assets/images/LogoMobile.svg";

defineProps({
  onClick: {
    type: Function,
    default: () => {},
  },
});
</script>
